
/**
 * Module dependencies.
 */

import { color, units } from 'src/styles/utils';
import { navElementAttrs } from 'src/components/navbar/nav-element';
import { theme } from 'styled-tools';
import styled from 'styled-components';

/**
 * `FooterLink` styled component.
 *
 * The links listed inside a footer column. Rendering is delegated to
 * `navElementAttrs` so an internal route, an external url and the `javascript:`
 * link of the ar simulator all behave correctly.
 */

const FooterLink = styled.a.attrs(navElementAttrs)`
  -webkit-tap-highlight-color: transparent;
  appearance: none;
  background: none;
  border: 0;
  color: ${color('white')};
  cursor: pointer;
  display: block;
  font-size: 14px;
  line-height: 1.5;
  outline: none;
  padding: ${units(1)} 0;
  text-align: left;
  text-decoration: none;
  transition: color ${theme('animations.fastTransition')};
  width: 100%;

  &:focus-visible,
  &:hover {
    color: ${color.transparentize('white', 0.7)};
    text-decoration: underline;
  }
`;

/**
 * Export `FooterLink` styled component.
 */

export default FooterLink;
